export default __webpack_public_path__ + "static/media/veh-0.75724505.png";